export const noopLogger = {
    trackEvent: async () => { },
    _internal: {
        ready: Promise.resolve(),
        anonId: "",
    },
};
//# sourceMappingURL=noop.js.map